import React from 'react';
import styled from 'styled-components';
import Card from 'react-bootstrap/Card';
import Header from './header';
import Pane from './pane';
import FundContext from './context';
import getManualOverrides from '../utils';
import {
  HeaderContainer,
  HeaderMixin,
  Column,
  RowContainer,
} from '../../shared/styles';

const Body = styled(Card.Body)`
  > a {
    margin-right: 20px;
  }
  margin-bottom: -16px;
`;

const DataColumn = styled(Column)`
  width: 33.3%;
  word-wrap: break-word;
`;

const HeaderColumn = styled(DataColumn)`
  ${HeaderMixin}
`;
const Rows = styled.div`
  & > *:last-child {
    border-bottom: none;
  }
`;

export default function ManualOverrides() {
  const { state: { fund } } = React.useContext(FundContext);
  const overrides = getManualOverrides(fund);

  return (
    <Card>
      <Card.Header>
        <Header eventKey="manual-overrides">Manual Overrides</Header>
      </Card.Header>
      <Pane eventKey="manual-overrides">
        <Body>
          <HeaderContainer>
            <HeaderColumn>Field</HeaderColumn>
            <HeaderColumn>Manual Value</HeaderColumn>
            <HeaderColumn>Data Provider Value</HeaderColumn>
          </HeaderContainer>
          <Rows>
            {overrides.map(override => (
              <RowContainer>
                <DataColumn>{override.field}</DataColumn>
                <DataColumn>{override.value}</DataColumn>
                <DataColumn>{override.dpValue}</DataColumn>
              </RowContainer>
            ))}
          </Rows>
        </Body>
      </Pane>
    </Card>
  );
}
